// dependency-graph-ignore-file
import { type Database } from '@databases/model/database';

export function updateSavedViewName(ydb: Database, viewId: string, delta: any[]): void {
  ydb.mutate((db) => {
    const view = db.viewsById[viewId];

    if (view) {
      view.applyNameDelta(delta);
    }
  });
}
